import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/close_icon.png'


const _hoisted_1 = { class: "commonPantryDialogOverlay" }
const _hoisted_2 = { class: "commonPantryDialogBox pantry-detail-guide-dialog-box" }
const _hoisted_3 = { class: "commonPantryDialogHeaderArea" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "commonPantryDialogCloseIcon",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "pantry-detail-guide-dialog" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", {
              class: "commonPantryDialogCloseImage",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
            }, [
              _hoisted_4
            ])
          ]),
          _createVNode("div", {
            innerHTML: _ctx.GUIDE_MESSAGE,
            class: "pantry-detail-guide-dialog-text"
          }, null, 8, ["innerHTML"])
        ])
      ])
    ]),
    _: 1
  }))
}